import React, { useEffect, useState } from 'react';
import FlashSaleCards from './FlashSaleCards';
import './styles/FlashSale.css';
import axios from 'axios';

const FlashSale: React.FC = () => {
  const [timeLeft, setTimeLeft] = useState({ hours: 0, minutes: 0, seconds: 0 });

  useEffect(() => {
    const fetchTimer = async () => {
      try {
  const response = await axios.get('https://backend.buildsupplyco.com/api/v1/products/deal-of-the-day');
        if (response.data && response.data.data && response.data.data.length > 0) {
          const deal = response.data.data[0];
          let remaining = deal.timeRemaining;
          if (remaining > 0) {
            const hours = Math.floor(remaining / (1000 * 60 * 60));
            const minutes = Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((remaining % (1000 * 60)) / 1000);
            setTimeLeft({ hours, minutes, seconds });
          }
        }
      } catch (error) {
        setTimeLeft({ hours: 0, minutes: 0, seconds: 0 });
      }
    };
    fetchTimer();

    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let { hours, minutes, seconds } = prev;
        if (seconds > 0) seconds--;
        else if (minutes > 0) { minutes--; seconds = 59; }
        else if (hours > 0) { hours--; minutes = 59; seconds = 59; }
        return { hours, minutes, seconds };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="flash-sale">
      <div className="flash-sale__left">
        <div className="flash-sale__countdown">
          <h2 className="flash-sale__title">Limited Sale</h2>
          <p className="flash-sale__subtitle">Get 25% off - Limited Time Offer</p>
          <div className="flash-sale__timer">
            <div className="flash-sale__timer-display">
              <div className="flash-sale__time-box">
                <span className="flash-sale__time-number">{timeLeft.hours.toString().padStart(2, '0')}</span>
              </div>
              <span className="flash-sale__time-separator">:</span>
              <div className="flash-sale__time-box">
                <span className="flash-sale__time-number">{timeLeft.minutes.toString().padStart(2, '0')}</span>
              </div>
              <span className="flash-sale__time-separator">:</span>
              <div className="flash-sale__time-box">
                <span className="flash-sale__time-number">{timeLeft.seconds.toString().padStart(2, '0')}</span>
              </div>
            </div>
            <div className="flash-sale__timer-labels">
              <span className="flash-sale__time-label">Hours</span>
              <span className="flash-sale__time-label">Minutes</span>
              <span className="flash-sale__time-label">Seconds</span>
            </div>
          </div>
        </div>
      </div>
      <div className="flash-sale__right">
        <FlashSaleCards />
      </div>
    </div>
  );
};

export default FlashSale;
